<main class="bg-background-light dark:bg-background-dark dark:text-white flex-1 p-8">
  <!-- Show list if no document selected -->
  <div *ngIf="!selectedDocument" class="flex flex-col gap-8">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
      <div
        *ngFor="let document of paginatedDocuments"
        class="bg-white dark:bg-card-dark rounded-xl shadow-md hover:shadow-xl transition-all duration-300 p-3 flex flex-col"
      >
        <!-- Thumbnail Section -->
        <div
          class="w-full h-40 mb-4 overflow-hidden rounded-lg bg-gray-100 dark:bg-gray-800 cursor-pointer group"
          (click)="viewDocument(document)"
        >
          <img
            *ngIf="document.thumbnailUrl"
            [src]="document.thumbnailUrl"
            [alt]="document.title"
            class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <div
            *ngIf="!document.thumbnailUrl"
            class="flex items-center justify-center h-full text-gray-400 text-sm"
          >
            No Image
          </div>
        </div>

        <!-- Title and Favorite -->
        <div class="flex items-center justify-between mb-1">
          <h3
            class="text-lg font-semibold text-text-light dark:text-text-dark line-clamp-1"
            title="{{ document.title }}"
          >
            {{ document.title }}
          </h3>

          <button
            (click)="toggleFavorite(document)"
            class="flex items-center cursor-pointer transition-transform duration-150 ease-out"
          >
            <svg
              *ngIf="document.favoritedByCurrentUser; else heartOutline"
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6 fill-current text-red-500 scale-110 transition-transform duration-150 ease-out"
              viewBox="0 0 24 24"
            >
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5
                      2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09
                      C13.09 3.81 14.76 3 16.5 3
                      19.58 3 22 5.42 22 8.5
                      c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
            </svg>

            <ng-template #heartOutline>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-6 h-6 fill-none stroke-current stroke-2 text-gray-400 hover:text-red-500 transition-transform duration-150 ease-out"
                viewBox="0 0 24 24"
              >
                <path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3
                        4.42 3 2 5.42 2 8.5
                        c0 3.78 3.4 6.86 8.55 11.54L12 21.35
                        l1.45-1.32C18.6 15.36 22 12.28 22 8.5
                        22 5.42 19.58 3 16.5 3z"/>
              </svg>
            </ng-template>
          </button>
        </div>

        <!-- Module and Description -->
        <span class="text-sm font-medium text-primary mb-3 line-clamp-1">
          {{ document.module }}
        </span>
        <p
          class="text-sm text-subtext-light dark:text-subtext-dark flex-grow line-clamp-2 mb-4"
          title="{{ document.description }}"
        >
          {{ document.description }}
        </p>

        <!-- Uploaded Date -->
        <p class="text-xs text-subtext-light dark:text-subtext-dark mb-4">
          Uploaded: {{ document.updatedAt }}
        </p>

        <!-- View Button -->
        <button
          class="w-full bg-primary text-white font-semibold py-2 px-4 rounded-lg hover:bg-primary/90 transition-colors cursor-pointer"
          (click)="viewDocument(document)"
        >
          View Document
        </button>
      </div>
    </div>

    <p *ngIf="documents.length === 0" class="text-center text-gray-500 dark:text-gray-400 mt-8">
      No documents found.
    </p>

    <!-- Pagination -->
    <div class="mt-8 flex justify-center" *ngIf="documents.length > 0">
      <app-pagination
        [currentPage]="currentPage"
        [totalPages]="Math.ceil(totalCount / limit)"
        [limit]="limit"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-pagination>
    </div>
  </div>

  <!-- Show Document Page -->
  <app-document-page
    *ngIf="selectedDocument"
    [selectedDoc]="selectedDocument"
    (back)="clearSelection()"
  ></app-document-page>
</main>
